import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from '~/resources/localstorage';
import { RootState } from '~/store/index';

export interface User {
  token: {
    refresh: string;
    access: string;
  };
  firstName: string;
}

export interface State {
  user: User;
  authenticated: boolean;
}

const defaultUser = () => ({
  token: {
    refresh: localStorage.getItem(REFRESH_TOKEN_KEY) || '',
    access: localStorage.getItem(ACCESS_TOKEN_KEY) || '',
  },
  firstName: '',
});

const initialState: State = {
  user: {
    ...defaultUser(),
  },
  authenticated: false,
};

const AuthSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    SET_AUTHENTICATED_USER(state, { payload }: PayloadAction<string>) {
      state.user = {
        token: { access: '1', refresh: '2' },
        firstName: payload,
      };
    },
    LOGOUT_USER(state) {
      localStorage.removeItem(REFRESH_TOKEN_KEY);
      localStorage.removeItem(ACCESS_TOKEN_KEY);

      state.user = { ...defaultUser() };
      state.authenticated = false;
      window.location.href = '/';
    },
    SET_USEREFRESH_TOKEN(state, { payload }: PayloadAction<string>) {
      state.user = {
        ...state.user,
        token: { refresh: state?.user?.token?.refresh || '', access: payload },
      };

      state.authenticated = true;
      localStorage.setItem(ACCESS_TOKEN_KEY, payload);
    },
  },
});

export const selectAuth = (state: RootState) => state.auth;
export const selectAuthToken = (state: RootState) => state.auth.user.token;

export const { SET_AUTHENTICATED_USER, LOGOUT_USER, SET_USEREFRESH_TOKEN } =
  AuthSlice.actions;

export default AuthSlice.reducer;
